
import { computed } from "vue";
import { useStore } from "vuex";
import { MessageType } from "@moderrotech/servers-communication-library/src/types";

export default {
  setup() {
    const store = useStore();

    return {
      suggestions: computed((): string[] => store.state.session.suggestions),
      handleClick: (text: string) =>
        store.dispatch("session/sendJsonMessage", {
          message: {
            type: MessageType.suggestionClick,
            item: text
          }
        })
    };
  }
};
